// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  userId: __t.string().primaryKey().name("user_id"),
  email: __t.string(),
  name: __t.string(),
  avatarUrl: __t.string().name("avatar_url"),
  superadmin: __t.bool(),
  superadminByEnv: __t.bool().name("superadmin_by_env"),
  suspended: __t.bool(),
  online: __t.bool(),
  orgCount: __t.u32().name("org_count"),
  createdAt: __t.timestamp().name("created_at"),
  lastLoginAt: __t.timestamp().name("last_login_at"),
  lastActiveAt: __t.timestamp().name("last_active_at"),
});
